var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuelltonne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Muelltonne__Icn/40px/Muelltonne",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Muelltonne__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Muelltonne__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.151592,14 L27.0273757,29 L12.9726243,29 L10.848408,14 L29.151592,14 Z M26.847,16 L13.152,16 L14.709,27 L25.29,27 L26.847,16 Z M23.857666,17 L23,26 L21,26 L21.857666,17 L23.857666,17 Z M18,17 L18.857666,26 L16.857666,26 L16,17 L18,17 Z M11,13 L11,11 L15.999408,11 L16,9 C16,8.48716416 16.3860402,8.06449284 16.8833789,8.00672773 L17,8 L23,8 C23.5522847,8 24,8.44771525 24,9 L23.999408,11 L29,11 L29,13 L11,13 Z M22,10 L18,10 L18,11 L22,11 L22,10 Z",
    id: ".._.._src_svg_Icn_40px_Muelltonne__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuelltonne);
export default __webpack_public_path__ + "static/media/Muelltonne.646fc6bb14a943d3405619dde4fd7214.svg";
export { ForwardRef as ReactComponent };